<template>
  <div class="nx-taxonomy-selector-by-media-wrapper">
    <div class="items">
      <v-layout row wrap align-center v-for="(media, index) in currentMedias" :key="media.id">
        <v-flex xs12 sm4>
          <v-select
            :items="availableMedias"
            chips
            :value="media.id"
            @input="updateMedia(index, $event)"
            item-text="name"
            item-value="id"
            item-disabled="disabled"
            label="Media"
            :placeholder="$t('message.taxonomy.selector.selectMedia')"
            prepend-icon="clear"
            return-object
            @click:prepend="removeMedia(media.id)"
          >
            <template v-slot:selection="{ item }">
              <v-tooltip bottom>
                <v-chip class="media" @click.stop="showSyncedFields" slot="activator">
                  <v-avatar color="secondary">
                    <v-icon size="20" color="white">fa-link</v-icon>
                  </v-avatar>
                  <span>{{ item.name }}</span>
                </v-chip>
                <span>{{ $t('message.taxonomy.selector.syncedFields') }}</span>
              </v-tooltip>
            </template>

          </v-select>
        </v-flex>
        <v-flex xs12 sm8 pl-5>
          <nx-taxonomy-selector
            v-if="media.type !== 'remoteMedia'"
            :key="media.id"
            :disabled="!media.id"
            :label="$t('message.taxonomy.selector.mediaCategories')"
            :media-id="media.id"
            :type="type"
            :value="valueByMediaId(media.id)"
            @input="setValueForMediaId($event, media.id)"
            disable-sort
          >
          </nx-taxonomy-selector>
          <nx-entity-selector
            :allow-edit-items="false"
            :custom-filters="{ mediaId: media.id }"
            :formated-items="valueByMediaId(media.id)"
            :label="$t('message.taxonomy.selector.mediaCategories')"
            :value="valueByMediaId(media.id)"
            @input="setValueForMediaId($event, media.id)"
            entity="remoteTaxon"
            icon="folder"
            searcher
            v-else
          ></nx-entity-selector>
        </v-flex>
      </v-layout>
    </div>
    <v-tooltip bottom dark v-if="currentMedias.length < availableMedias.length">
      <template v-slot:activator="{ on }">
        <v-btn block color="primary" @click="addMedia" outline>
          <v-icon>add_circle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('message.taxonomy.selector.addMedia') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { isEqual, uniqBy } from 'lodash';
import NxTaxonomySelector from '@/modules/taxonomy/selector/Selector';

/**
 * Taxonomy Selector split by media.
 */
export default {
  name: 'nx-taxonomy-selector-by-media',
  components: {
    NxTaxonomySelector,
  },
  props: {
    allowOnlyRemoteMedias: Boolean,
    allowOnlyMediaIds: {
      type: Array,
      default: () => [],
    },
    dontFilterCentralNewsroomMediaIds: {
      type: Array,
      default: () => ([]),
    },
    limit: {
      type: Number,
    },
    type: {
      type: [String, Array],
    },
    value: {
      type: Array,
      default: () => [],
    },
    allowRootValue: {
      type: Boolean,
      default: false,
    },
    limitCounter: {
      type: Boolean,
      default: true,
    },
    excludedMediaIds: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    remoteMedias: {
      type: Array,
      required: false,
      default: () => ([]),
      // validator(value) {
      //   return value.every(remoteMedia => isObject(remoteMedia)
      //     && ['id', 'name', 'type'].every(prop => !isEmpty(remoteMedia[prop])));
      // },
    },
  },
  data() {
    return {
      currentMedias: this.getMediasFromTaxons(this.value),
    };
  },
  computed: {
    valueByMediaId() {
      return id => this.value.filter(taxon => taxon.media.id === id);
    },
    availableMedias() {
      const medias = this.allowOnlyRemoteMedias
        ? []
        : this.$store.getters.availableMedias
          .filter(
            this.allowOnlyMediaIds.length > 0
              ? media => this.allowOnlyMediaIds.includes(media.id)
              : () => true,
          )
          .filter(media => !media.isCentralNewsroom || this.dontFilterCentralNewsroomMediaIds.includes(media.id))
          .map(media => ({ id: media.id, name: media.name, type: media.type || 'media' }));
      return medias
        .concat(this.remoteMedias)
        .map(media => ({
          ...media,
          disabled: this.currentMedias.find(currentMedia => media.id === currentMedia.id) !== undefined,
        }));
    },
  },
  methods: {
    showSyncedFields() {
      // TODO
    },
    addMedia() {
      this.currentMedias.push({ id: null });
    },
    updateMedia(index, media) {
      this.currentMedias.splice(index, 1, media);
    },
    removeMedia(mediaId) {
      this.currentMedias = this.currentMedias.filter(media => media.id !== mediaId);
      if (this.value.length > 0) {
        this.$emit('input', this.value.filter(taxon => taxon.media.id !== mediaId));
      }
    },
    setValueForMediaId(value, mediaId) {
      console.log('setValueForMediaId', value, mediaId);
      this.$emit('input', uniqBy([
        ...this.value.filter(taxon => taxon.media.id !== mediaId),
        ...value,
      ], taxon => taxon.id));
    },
    getMediasFromTaxons(taxons) {
      const medias = taxons.reduce((acc, taxon) => {
        acc[taxon.media.id] = taxon.media;
        return acc;
      }, {});
      return Object.values(medias)
        .sort((a, b) => a.id - b.id); // Keep medias sorted
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (isEqual(newValue, oldValue)) {
        return;
      }
      const medias = this.getMediasFromTaxons(newValue);
      if (this.currentMedias.length !== medias) {
        this.currentMedias = medias;
      }
    },
  },
};
</script>

<style lang="stylus">
.nx-taxonomy-selector-by-media-wrapper .media .v-chip__content {
  cursor: pointer
}
</style>
